<template>
  <div>
    <Head title="Yield" />
    <h1 class="mb-8 text-3xl font-bold">Yield</h1>
    <div class="flex items-center justify-between mb-6">
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      <a
        v-if="yield_summary.length > 0"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/blocks/yield-summary/download/${form.dateValue}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Category</th>
          <th class="pb-4 pt-6 px-6">Blocks Cut</th>
          <th class="pb-4 pt-6 px-6">Block Volume(m<sup>3</sup>)</th>
          <th class="pb-4 pt-6 px-6">Output Volume(m<sup>3</sup>)</th>
          <th class="pb-4 pt-6 px-6">Quality Output Volume(m<sup>3</sup>)</th>
          <th class="pb-4 pt-6 px-6">Overall Yield</th>
          <th class="pb-4 pt-6 px-6">Quality Yield</th>
        </tr>
        <tr
          v-for="block in yield_summary"
          :key="block.blocks_category"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.blocks_category }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.blocks_cut }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.total_block_volume }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.total_output_volume }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.total_quality_output_volume }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.overall_yield }}%
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.quality_yield }}%
            </span>
          </td>
        </tr>
        <tr v-if="yield_summary.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">No data found</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    SearchWithDateRange,
    DateRange,
    Pagination
  },
  layout: Layout,
  props: {
    filters: Object,
    yield_summary: Array,
  },
  data() {
    return {
      form: {
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/blocks/yield', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
